import { StateModel } from '../../../shared/definition/model/state.model';

export const mainStates: Array<StateModel> = [
    {
        path: 'health/analysis/journey',
        name: 'Amostras',
        base: 'health/analysis/journey',
        icon: 'uii-microscope',
        roles: ['ciera-tech'],
        fontSize: '1.8rem'
    }, {
        path: 'health/analysis/type',
        base: 'health/analysis/type',
        roles: ['ciera-tech'],
        name: 'Exames',
        icon: 'uii-flask',
        fontSize: '2.4rem'
    }
];

export const managementStates: Array<StateModel> = [
    {
        path: 'iam/management/role',
        base: 'iam/management/role',
        roles: ['ciera-tech'],
        name: 'Perfis',
        icon: 'uii-shield-key',
        fontSize: '2rem'
    }, {
        icon: 'uii-users',
        name: 'Usuários',
        path: 'iam/management/user',
        base: 'iam/management/user',
        fontSize: '2.2rem',
        roles: ['ciera-tech']
    }, {
        icon: 'uii-city',
        name: 'Parceiros',
        path: 'partner',
        base: 'partner',
        fontSize: '2.2rem',
        roles: ['ciera-tech']
    }, {
        icon: 'uii-mail',
        name: 'E-mails',
        path: 'email',
        base: 'email',
        fontSize: '2rem',
        roles: ['ciera-tech']
    }, {
        icon: 'uii-users',
        name: 'Self-onboarding',
        path: 'self-onboarding',
        base: 'self-onboarding',
        fontSize: '2rem',
        roles: ['ciera-tech']
    }
]
